// src/context/ServiceRequestContext.tsx
import React, { createContext, useContext } from "react";

export const ServiceRequestContext = createContext<any>(null);

/**
 * Strict: use only when you are guaranteed to be under the provider.
 * Helpful during development, but can crash during auth/provider teardown.
 */
export const useServiceRequest = () => {
  const ctx = useContext(ServiceRequestContext);
  if (!ctx) {
    throw new Error("useServiceRequest must be used within a ServiceRequestProvider");
  }
  return ctx;
};

/**
 * Safe: returns null when provider is missing (e.g. during sign-out teardown).
 * Use this in route-level components that may briefly render while providers reset.
 */
export const useOptionalServiceRequest = () => {
  return useContext(ServiceRequestContext) ?? null;
};
